import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { CarouselButtonScrollType, CarouselType } from '../../types';

@Component({
  selector: 'carousel-button',
  templateUrl: './carousel-button.component.html',
  styleUrls: ['./carousel-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselButtonComponent {
  @Input() type: CarouselButtonScrollType = 'forward-bottom';
  @Input() variant: CarouselType = 'horizontal';
  @Input() visible = true;

  @Output() scrollPanel = new EventEmitter<CarouselButtonScrollType>();

  get icon() {
    if (this.type === 'backward-top') {
      return this.variant === 'horizontal' ? '@tui.chevron-left' : '@tui.chevron-up';
    } else {
      return this.variant === 'horizontal' ? '@tui.chevron-right' : '@tui.chevron-down';
    }
  }
}
